import React, { forwardRef, useState, useEffect, useContext } from "react"
import { Col, Form, Row, Tab, Tabs } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import DatePicker from "react-datepicker"
import toast from "react-hot-toast"
import Moment from "moment"
import { CSVLink, CSVDownload } from "react-csv"
// components
import Navbar from "../../Components/Navbar/Navbar"
import Table from "../../Components/TableTemplate/OneTable"
import DeleteModal from "../../Components/Modals/DeleteModal"
import PettyCashModal from "./PettyCashModal"
import AdjustmentTable from "./../Inventory/Adjustment/AdjustmentTable"
import MarkModal from "./../PettyCash/MarkModal"
import * as XLSX from "xlsx"

// api calls and utils
import {
  searchPettyCashTransactionDetails,
  deletePettyCashTransactionDetails,
  getPettyCashInfo,
  approvePettyCashRequest,
} from "../../Helpers/apiCalls/PettyCash/PettyCashRegisterApi"

import {
  getTodayDateISO,
  getType,
  refreshPage,
  toastStyle,
  formatYDM,
  numberFormat,
  getUser,
} from "../../Helpers/Utils/Common"

// css
import "./PettyCash.css"
import downloadIcon from "../../Assets/Images/download_icon.png"
import Footer from "../../Components/Footer/Footer"
import { Context } from "../../Helpers/Utils/Context"
import moment from "moment"
/**
 *  Petty Cash Register component
 */

export default function PettyCash() {
  let navigate = useNavigate()
  const { setDateFrom, setDateTo, dateFilter, currentTab, setCurrentTab } =
    useContext(Context)

  const dateToday = getTodayDateISO()
  const accountType = getType()
  const [inactive, setInactive] = useState(true)
  const [pettyCashID, setPettyCashID] = useState("1")
  const [pettyCashInfo, setPettyCashInfo] = useState({})
  const [pettyCashTransactions, setPettyCashTransactions] = useState([])
  const [isDeleteClicked, setIsDeleteClicked] = useState(false)
  const [isClicked, setIsClicked] = useState(false)
  const [checkedPayments, setCheckedPayments] = useState([])
  const [excelData, setExcelData] = useState([])

  /* Modal */
  const [showApproveModal, setShowApproveModal] = useState(false)
  const handleShowApproveModal = () =>
    checkedPayments.length != 0
      ? setShowApproveModal(true)
      : toast.error("Please select payment to mark as done", {
          style: toastStyle(),
        })
  const handleCloseApproveModal = () => setShowApproveModal(false)

  const date = new Date()
  date.setDate(date.getDate() - 7)

  const nextDay = new Date()
  nextDay.setDate(nextDay.getDate())

  /* FILTER CONFIGS */
  const [filterConfig, setFilterConfig] = useState({
    tab: currentTab
      ? currentTab
      : accountType === "admin"
      ? "request"
      : "all-register",
    transaction_type: "",
    date_from: dateFilter.date_from
      ? dateFilter.date_from
      : accountType === "admin"
      ? ""
      : date,
    date_to: dateFilter.date_to
      ? dateFilter.date_to
      : accountType === "admin"
      ? ""
      : nextDay,
    status: accountType === "admin" ? "request" : "approved",
  })

  function handleFilterChange(e) {
    const { name, value } = e.target
    const newConfig = { ...filterConfig, [name]: value }
    setFilterConfig(newConfig)
  }

  function filterPettyCashTransactions() {
    searchTransactionsApi()
  }

  useEffect(() => {
    filterPettyCashTransactions()
  }, [filterConfig])

  const xlsxHeaders = [
    "Date",
    "Particulars",
    "Requested By",
    "Cash In",
    "Cash Out",
    "Balance",
    "Added By",
    "Added On",
  ]

  const excelHeaders = [
    { label: "Date", key: "date" },
    { label: "Particulars", key: "particulars" },
    { label: "Requested By", key: "requested_by_name" },
    { label: "Cash In", key: "cashin_amount" },
    { label: "Cash Out", key: "cashout_amount" },
    { label: "Balance", key: "current" },
    { label: "Added By", key: "added_by_name" },
    { label: "Added On", key: "added_on" },
  ]

  const [showLoader, setShowLoader] = useState(false)

  async function searchTransactionsApi() {
    setExcelData([])

    setShowLoader(true)
    var params = {
      petty_cash_id: pettyCashID,
      ...filterConfig,
    }
    const response = await searchPettyCashTransactionDetails(params)

    if (response.status === "error") {
      toast.error(response.data.response, {
        style: toastStyle(),
      })
    } else if (response.status === "success") {
      var newData = response.history.map((data) => {
        var newData = data
        newData.from = data.from ? data.from : " "
        newData.particulars = data.particulars ? data.particulars : " "
        newData.particulars = data.from + " " + data.particulars
        if (newData.type === "out") {
          newData.cashin_amount = ""
          newData.cashout_amount = numberFormat(newData.amount)
        } else {
          newData.cashin_amount = numberFormat(newData.amount)
          newData.cashout_amount = ""
        }
        newData.date = Moment(data.date).format("MMM DD, YYYY")
        newData.added_on = Moment(data.added_on).format("MMM DD,YYYY")

        newData.current = numberFormat(newData.current)
        return newData
      })
      newData = newData.sort((transaction_1, transaction_2) => {
        return Moment(transaction_1.date).isBefore(transaction_2.date)
      })
      setPettyCashTransactions(newData)

      var excel = newData.map((bill) => {
        var info = {}
        info.date = bill.date
        info.particulars = bill.particulars
        info.requested_by_name = bill.requested_by_name
        info.cashin_amount = bill.cashin_amount
        info.cashout_amount = bill.cashout_amount
        info.current = bill.current
        info.added_by_name = bill.added_by_name
        info.added_on = bill.added_on
        return info
      })
      setExcelData(excel)
    } else {
      var errMsg = response.error
      toast.error(errMsg, { style: toastStyle() })
    }
    setShowLoader(false)
  }

  async function fetchPettyCashInfo() {
    const response = await getPettyCashInfo({ petty_cash_id: pettyCashID })
    if (response.error) {
      toast.error(response.error.data.messages.error, {
        style: toastStyle(),
      })
    } else {
      if (response.status === "error") {
        toast.error(response.error.data.messages.error, {
          style: toastStyle(),
        })
      } else if (response.status === "success") {
        setPettyCashInfo({ ...response["data"] })
      } else {
        var errMsg = response.error
        toast.error(errMsg, { style: toastStyle() })
      }
    }
  }

  console.log(checkedPayments)

  async function handleApprovePettyCashRequest() {
    setIsClicked(true)
    const response = await approvePettyCashRequest(checkedPayments)
    if (response.error) {
      toast.error(response.error.data.messages.error, {
        style: toastStyle(),
      })
    } else {
      toast.success(response.response, {
        style: toastStyle(),
      })
      setShowApproveModal(false)
      fetchPettyCashInfo()
      searchTransactionsApi()
    }
    setIsClicked(false)
  }

  useEffect(() => {
    fetchPettyCashInfo()
  }, [])

  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const handleShowDeleteModal = () => setShowDeleteModal(true)
  const handleCloseDeleteModal = () => setShowDeleteModal(false)
  const [transactionDetailID, setTransactionDetailID] = useState("")

  async function handleDeleteTransaction() {
    if (isDeleteClicked) {
      return
    }
    setIsClicked(true)
    setIsDeleteClicked(true)
    const response = await deletePettyCashTransactionDetails(
      transactionDetailID
    )

    if (response.status === "success") {
      toast.success("Petty Cash Transaction Deleted Successfully!", {
        style: toastStyle(),
      })
      setShowDeleteModal(false)
      fetchPettyCashInfo()
      searchTransactionsApi()
      //   setTimeout(() => refreshPage(), 1000);
    } else {
      toast.error("Error Deleting Petty Cash Transaction", {
        style: toastStyle(),
      })
    }
    setIsClicked(false)
    setIsDeleteClicked(false)
  }

  function handleSelectChange(e, id, type, row) {
    if (e.target.value === "edit-pi") {
      if (type === "in") {
        navigate("/pettycash/cashin/" + id + "/edit/")
      } else if (type === "out") {
        navigate("/pettycash/cashout/" + id + "/edit/")
      }
    } else if (e.target.value === "delete-pi") {
      setTransactionDetailID(id)
      handleShowDeleteModal()
    } else if (e.target.value === "view-btn") {
      if (type === "in") {
        navigate("/pettycash/cashin/" + id)
      } else if (type === "out") {
        navigate("/pettycash/cashout/" + id)
      }
    } else if (e.target.value === "approve-btn") {
      setCheckedPayments(row)
      setShowApproveModal(true)
    }
  }

  const handleTabSelect = (tabKey) => {
    setCurrentTab(tabKey)
    var newFilterConfig = {
      ...filterConfig,
      tab: tabKey,
    }
    switch (tabKey) {
      case "all-register":
        newFilterConfig.tab = "all-register"
        newFilterConfig.status = "approved"
        newFilterConfig.date_from = dateFilter.date_from || date
        newFilterConfig.date_to = dateFilter.date_to || nextDay
        setFilterConfig(() => {
          return newFilterConfig
        })
        break
      case "request":
        newFilterConfig.tab = "request"
        newFilterConfig.status = "request"
        newFilterConfig.date_from = dateFilter.date_from || ""
        newFilterConfig.date_to = dateFilter.date_to || ""
        setFilterConfig(() => {
          return newFilterConfig
        })
        // setFilterConfig((prev) => {
        //     return {
        //         ...prev,
        //         newFilterConfig,
        // }});
        break
      default:
        break
    }
  }

  function handleOnCheck(row) {
    setCheckedPayments(row.selectedRows)
  }

  function ActionBtn(row, type) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action"
        onChange={(e) => handleSelectChange(e, row.id, row.type, row)}
      >
        <option value="" hidden selected>
          Select
        </option>

        {(accountType === "admin" || accountType === "franchise_officer") &&
          type === "request" && (
            <option value="view-btn" className="color-options">
              View
            </option>
          )}
        {accountType === "admin" || accountType === "franchise_officer" ? (
          <option value="edit-pi" className="color-options">
            Edit
          </option>
        ) : null}
        {(accountType === "admin" || accountType === "franchise_officer") &&
          type === "request" && (
            <option value="approve-btn" className="color-options">
              Approve
            </option>
          )}
        {(accountType === "admin" ||
          accountType === "franchise_officer" ||
          (accountType === "purchasing_officer" && type === "request")) && (
          <option value="delete-pi" className="color-red">
            Delete
          </option>
        )}
      </Form.Select>
    )
  }
  const [selected, setSelected] = useState({})

  function ViewBtn(row) {
    return (
      <button
        name="action"
        className="btn btn-sm view-btn-table"
        id={row.id}
        onClick={(e) => handleSelectChange(e, row.id, row.type, row)}
        value="view-btn"
      >
        View
      </button>
    )
  }

  function ApproveBtn(row) {
    if (accountType === "admin") {
      return (
        <button
          name="action"
          className="btn btn-sm view-btn-table"
          id={row.id}
          onClick={(e) => handleApprove(row)}
          value="approve-btn"
        >
          Approve
        </button>
      )
    }
  }
  function handleApprove(row) {
    setSelected(row)
    handleShowApproveModal()
  }

  function handleExport() {
    const rows = excelData

    /* generate worksheet and workbook */
    const worksheet = XLSX.utils.json_to_sheet(rows)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1")
    XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" })
    XLSX.writeFile(workbook, "PettyCash.xlsx", { compression: true })
  }

  React.useEffect(() => {
    // fetchTransactions();
  }, [])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"PETTY CASH"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* headers */}
        <Row className="mb-4">
          <Col xs={12} lg={8}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              PETTY CASH REGISTER{" "}
            </h1>
          </Col>
          <Col
            xs={12}
            lg={2}
            className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3 mb-3 mb-lg-0"
          >
            <button
              className="add-btn"
              onClick={() => navigate("/pettycash/cashin")}
            >
              Cash In
            </button>
          </Col>
          <Col
            xs={12}
            lg={2}
            className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3"
          >
            <button
              className="add-btn"
              onClick={() => navigate("/pettycash/cashout")}
            >
              Cash Out
            </button>
          </Col>
          <Col lg={10} className="mt-4 mt-lg-0">
            <h4 className="page-subtitle ps-2 ps-md-0 ms-md-0 fs-4">
              {" "}
              Current Petty Cash: {"\u20B1"}
              {numberFormat(pettyCashInfo.current_petty_cash)}
            </h4>
          </Col>
        </Row>
        <Tabs
          activeKey={filterConfig.tab}
          id="petty-cash-tabs"
          onSelect={handleTabSelect}
        >
          <Tab eventKey="all-register" title="ALL REGISTER">
            {/* filters */}
            <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
              Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={12} lg={2} className="mb-2 mb-lg-0">
                <Form.Select
                  name="type"
                  className="date-filter force-width w-full"
                  defaultValue={filterConfig.type}
                  onChange={(e) => {
                    setFilterConfig((prev) => {
                      return { ...prev, type: e.target.value }
                    })
                  }}
                >
                  <option value="" selected>
                    All Transactions
                  </option>
                  <option value="in">Cash In</option>
                  <option value="out">Cash Out</option>
                </Form.Select>
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  placeholderText={Moment(date).format("MM/DD/YYYY")}
                  selected={filterConfig.date_from}
                  name="date_from"
                  onChange={(date) => {
                    setDateFrom(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_from: date }
                    })
                  }}
                  dateFormat="MMM dd,yyyy"
                  dateFormatCalendar="MMMM"
                  maxDate={dateToday}
                  fixedHeight
                  className="date-filter me-4 form-control"
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  placeholderText={Moment(nextDay).format("MM/DD/YYYY")}
                  selected={filterConfig.date_to}
                  name="date_to"
                  onChange={(date) => {
                    setDateTo(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_to: date }
                    })
                  }}
                  dateFormat="MMM dd,yyyy"
                  dateFormatCalendar="MMMM"
                  maxDate={dateToday}
                  minDate={filterConfig.date_from}
                  className="date-filter ps-label-content me-5 form-control"
                />
              </Col>
            </Row>
            <div className="mb-2" />

            {/* content */}
            <div className="pettycash-tbl">
              <Table
                tableHeaders={[
                  "-",
                  "DATE",
                  // "FROM",
                  "PARTICULARS",
                  "REQ BY",
                  "CASH IN",
                  "CASH OUT",
                  "BALANCE",
                  "ADDED BY",
                  "ADDED ON",
                  "ACTIONS",
                ]}
                headerSelector={[
                  "-",
                  "date",
                  // "from",
                  "particulars",
                  "requested_by_name",
                  "cashin_amount",
                  "cashout_amount",
                  "current",
                  "added_by_name",
                  "added_on",
                  "actions",
                ]}
                tableData={pettyCashTransactions}
                ActionBtn={(row) => ActionBtn(row, "all")}
                ViewBtn={(row) => ViewBtn(row)}
                showLoader={showLoader}
                withActionData={false}
              />
            </div>
            <div className="mb-2" />
          </Tab>
          <Tab eventKey="request" title="CASH REQUEST" className="px-3">
            {/* filters */}
            <div className="mb-3" />
            <span className="mb-2 align-middle d-none d-md-inline d-flex text-secondary">
              Filter By:
            </span>
            <Row className="PO-filters flex flex-row my-1">
              <Col xs={12} lg={2} className="mb-2 mb-lg-0">
                <Form.Select
                  name="type"
                  cclassName="date-filter force-width w-full"
                  defaultValue={filterConfig.type}
                  onChange={(e) => {
                    setFilterConfig((prev) => {
                      return { ...prev, type: e.target.value }
                    })
                  }}
                >
                  <option value="" selected>
                    All Transactions
                  </option>
                  <option value="in">Cash In</option>
                  <option value="out">Cash Out</option>
                </Form.Select>
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  placeholderText={"Select date from"}
                  selected={filterConfig.date_from}
                  name="date_from"
                  onChange={(date) => {
                    setDateFrom(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_from: date }
                    })
                  }}
                  dateFormat="MMM dd,yyyy"
                  maxDate={dateToday}
                  fixedHeight
                  className="date-filter me-4 form-control"
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  placeholderText={"Select date to"}
                  selected={filterConfig.date_to}
                  name="date_to"
                  onChange={(date) => {
                    setDateTo(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_to: date }
                    })
                  }}
                  dateFormat="MMM dd,yyyy"
                  maxDate={dateToday}
                  minDate={filterConfig.date_from}
                  className="date-filter ps-label-content me-5 form-control"
                />
              </Col>
            </Row>
            <div className="mb-2" />

            {/* content */}
            <div className="pettycash-tbl">
              <AdjustmentTable
                tableHeaders={[
                  // "-",
                  "DATE",
                  // "FROM",
                  "PARTICULARS",
                  "REQ BY",
                  // "CASH IN",
                  "CASH OUT",
                  "BALANCE",
                  "TYPE",
                  "ADDED BY",
                  "ADDED ON",
                  "ACTIONS",
                ]}
                headerSelector={[
                  // "-",
                  "date",
                  // "from",
                  "particulars",
                  "requested_by_name",
                  // "cashin_amount",
                  "cashout_amount",
                  "current",
                  "out_type",
                  "added_by_name",
                  "added_on",
                  "actions",
                ]}
                tableData={pettyCashTransactions}
                ActionBtn={(row) => ActionBtn(row, "request")}
                ViewBtn={(row) => ApproveBtn(row)}
                handleOnCheck={(row) => handleOnCheck(row)}
                showLoader={showLoader}
                withActionData={false}
              />
            </div>
            <div className="mb-2" />
          </Tab>
        </Tabs>
        {filterConfig.tab === "request" && accountType === "admin" ? (
          <>
            <Row className="mb-1">
              <Col lg={10} className="mt-4 mt-lg-0"></Col>
              <Col lg={2} className="mt-2 mt-lg-0">
                <div className="PO-filters">
                  <button
                    type="button"
                    className="add-btn"
                    onClick={() => handleShowApproveModal()}
                  >
                    Approve
                  </button>
                </div>
              </Col>
            </Row>
          </>
        ) : (
          <></>
        )}
        <Row className="mb-4">
          <Col lg={10}></Col>
          <Col lg={2} className="mt-2 mt-lg-0">
            <div className="PO-filters">
              <button
                type="button"
                className="primary-btn"
                onClick={handleExport}
              >
                <span className="me-2">
                  <img width={20} height={20} src={downloadIcon}></img>
                </span>
                Download
              </button>
            </div>
          </Col>
        </Row>
        <br />
        <br />
      </div>
      <MarkModal
        show={showApproveModal}
        hide={handleCloseApproveModal}
        type="approve this cash request?"
        ids={checkedPayments}
        handler={() => handleApprovePettyCashRequest()}
        isClicked={isClicked}
      />
      <DeleteModal
        show={showDeleteModal}
        onHide={() => handleCloseDeleteModal()}
        text="petty cash transaction"
        onDelete={() => handleDeleteTransaction()}
        isClicked={isClicked}
      />
      <Footer />
    </div>
  )
}
